const fixRVSpaces = (str: string): string => str.replace(/R V/g, 'RV');

const toTitleCase = (str: string): string =>
  str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

const splitCamelCase = (str: string): string => str.replace(/([A-Z])/g, ' $1');

export const camelToTitle = (str: string): string => fixRVSpaces(toTitleCase(splitCamelCase(str)));
